import { Outlet } from 'react-router';

import { BrandLogo } from '@/components/ui/BrandLogo';

import styles from './AuthLayout.module.css';

/** Log in and change password: the form on the left, the Club29 brand panel on the right. */
export function AuthLayout() {
  return (
    <div className={styles.layout}>
      <div className={styles.formSide}>
        <div className={styles.formColumn}>
          <BrandLogo size="md" caption="GYM · FRONT DESK" />
          <Outlet />
        </div>
      </div>

      <aside className={styles.brandPanel} aria-hidden="true">
        <span className={styles.watermark}>29</span>
        <div className={styles.brandContent}>
          <BrandLogo size="lg" badgeOnly />
          <p className={styles.tagline}>
            Members, enquiries and memberships
            <br />
            in one place.
          </p>
        </div>
      </aside>
    </div>
  );
}
